// import { acquireLock, releaseLock } from './lockMechanism';

// #region write functions
export async function appendDataInFile(
  fileHandle: FileSystemFileHandle,
  data: string
) {
  try {
    // @ts-ignore
    const writableStream = await fileHandle.createWritable({
      keepExistingData: true,
    });
    const fileSize = (await fileHandle.getFile()).size;

    await writableStream.write({
      type: 'write',
      data: data + '\n',
      position: fileSize,
    });
    await writableStream.close();
    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
}

export async function saveDataInFile(
  fileHandle: FileSystemFileHandle,
  encData: string
) {
  // @ts-ignore
  const fileWS = await fileHandle.createWritable();
  await fileWS.write(encData);
  await fileWS.close();
}

export async function removeDataFromFile(fileHandle: FileSystemFileHandle) {
  try {
    // @ts-ignore
    const writeable = await fileHandle.createWritable();
    await writeable.truncate(0);
    await writeable.close();
  } catch (err) {
    console.log('err', err);
  }
}
// #endregion

// #region read functions
export const getFileContentsAsText = async (file: File) => {
  let contents: string = '';
  await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = () => reject('unable to read file');
    reader.readAsText(file);
  })
    .then((fileText) => (contents = fileText as string))
    .catch((err) => console.log(err));

  return contents;
};

export const readFileContents = async (fileHandle: FileSystemFileHandle) => {
  const file = await fileHandle.getFile();
  return await getFileContentsAsText(file);
};

export async function doesFileExist(
  directoryHandle: FileSystemDirectoryHandle,
  name: string
) {
  try {
    await directoryHandle.getFileHandle(name); // Try to get the file
    return true; // File exists
  } catch (error) {
    return false; // File doesn't exist
  }
}
// #endregion
